import { Exclude } from 'class-transformer';
import {
  ArrayMinSize,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
} from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../base.dto';
import { TrainingAssessmentDto } from '../training/training-assessment.dto';
import type { LearnReportTypeDto } from './learn-report-type.dtos';

export interface LearnReportDto extends BaseDto {
  userDescription?: string;
  adminNote?: string;
  trainingAssessment?: TrainingAssessmentDto;
  trainingAssessmentId?: string;
  discarded?: boolean;
  reportTypes: LearnReportTypeDto[];
}

export class CreateLearnReportDto
  extends BaseCreateDto
  implements Partial<LearnReportDto>
{
  @IsOptional()
  @IsString()
  userDescription?: string;

  @Exclude()
  adminNote?: never;

  @Exclude()
  trainingAssessment?: never;

  @IsOptional()
  @IsUUID()
  trainingAssessmentId?: string;

  @Exclude()
  reportTypes?: never[];

  @IsOptional()
  @ArrayMinSize(1)
  @IsUUID('all', { each: true })
  reportTypeIds?: string[];
}

export class UpdateLearnReportDto
  extends BaseUpdateDto
  implements Partial<LearnReportDto>
{
  @Exclude()
  userDescription?: never;

  @IsOptional()
  @IsString()
  adminNote?: string;

  @IsOptional()
  discarded?: boolean;

  @Exclude()
  trainingAssessment?: never;

  @Exclude()
  trainingAssessmentId?: never;

  @Exclude()
  reportTypes?: never[];

  @IsOptional()
  @ArrayMinSize(1)
  @IsUUID('all', { each: true })
  reportTypeIds?: string;
}

export class LearnReportSearchQueryDto {
  @IsNumber()
  @Min(0)
  skip: number;

  @IsNumber()
  @Min(1)
  take: number;

  // If null, shows discarded and not discarded
  // @IsOptional()
  // @IsBoolean()
  // @Transform(({ value }) => {
  //   console.log('Transforming value', value);
  //   return value === 'true';
  // })
  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(1)
  showDiscarded?: number;

  // Filter to specific report type id
  @IsOptional()
  @IsString()
  @IsUUID()
  reportTypeId?: string;
}
